<template>
  <div>
    <PageHeader :items="items" />
    <validation-observer ref="simpleRules">
      <div class="card">
        <div class="card-body">
          <b-row>
            <b-col cols="12" lg="6" md="6" class="mb-1">
              <label class="input-label form-label"
                >{{ $t("upperJawTemplate") }}
              </label>
              <div v-if="$can(`${$route.meta.permission}-file.save`)" class="">
                <input
                  type="file"
                  ref="upperInput"
                  @change="addFile($event, 'upper')"
                  accept=".stl, .obj"
                />
              </div>
              <div v-if="upperJawTemplate" class="mt-1">
                <b-button
                  variant="primary"
                  @click="handlePreviewClick('upper')"
                >
                  <span>{{ $t("previewUpperJaw") }}</span>
                </b-button>
              </div>
              <div
                v-if="form.upperJawTemplate && form.upperJawTemplate.name"
                class="cursor-pointer mt-1"
                @click="deleteFile('upper')"
              >
                <feather-icon size="16" icon="TrashIcon" style="color: red" />
              </div>
            </b-col>
            <b-col cols="12" lg="6" md="6" class="mb-1">
              <label class="input-label form-label"
                >{{ $t("lowerJawTemplate") }}
              </label>
              <div v-if="$can(`${$route.meta.permission}-file.save`)" class="">
                <input
                  type="file"
                  ref="lowerInput"
                  @change="addFile($event, 'lower')"
                  accept=".stl, .obj"
                />
              </div>
              <div v-if="lowerJawTemplate" class="mt-1">
                <b-button
                  variant="primary"
                  @click="handlePreviewClick('lower')"
                >
                  <span>{{ $t("previewLowerJaw") }}</span>
                </b-button>
              </div>
              <div
                v-if="form.lowerJawTemplate && form.lowerJawTemplate.name"
                class="cursor-pointer mt-1"
                @click="deleteFile('lower')"
              >
                <feather-icon size="16" icon="TrashIcon" style="color: red" />
              </div>
            </b-col>
            <b-col cols="12" lg="6" md="6" class="mb-1">
              <TextInput
                v-model="form.technology"
                type="text"
                :label="$t('technology')"
                :tooltipMessage="$t('technology')"
              />
              <div v-if="defaultTechnology">
                <h4 class="text-muted">
                  {{ $t("envValueSet") }}: {{ defaultTechnology }}
                </h4>
              </div>
            </b-col>
            <b-col cols="12" lg="6" md="6" class="mb-1">
              <TextInput
                v-model="form.toothCreditsCost"
                type="number"
                :label="$t('toothCreditsCost')"
                :tooltipMessage="$t('toothCreditsCost')"
              />
            </b-col>
            <b-col cols="12" lg="6" md="6" class="mb-1">
              <TextInput
                v-model="form.vhfKey"
                type="string"
                :label="$t('vhfKey')"
                :tooltipMessage="$t('vhfKey')"
              />
            </b-col>
            <template v-for="product in products">
              <b-col cols="12" class="mt-2">
                <h3 class="mb-1">{{ $t(product.label) }}</h3>
              </b-col>
              <b-col cols="12" lg="12" md="12">
                <b-row>
                  <b-col cols="12" lg="4" md="4" class="mb-1">
                    <TextInput
                      v-model="form[`${product.key}FeedbackFormUrl`]"
                      type="text"
                      :label="$t('feedbackFormTargetUrl')"
                      :tooltipMessage="$t('feedbackFormTargetUrl')"
                    />
                  </b-col>
                  <b-col cols="12" lg="4" md="4" class="mb-1">
                    <div class="form-group mt-1">
                      <label class="input-label form-label">{{
                        $t("feedbackFormSetActive")
                      }}</label>
                      <input
                        class="form-check-input-custom ml-2"
                        v-model="form[`${product.key}FeedbackFormActive`]"
                        type="checkbox"
                      />
                    </div>
                  </b-col>
                  <b-col cols="12" lg="4" md="4" class="mb-1">
                    <div class="form-group mt-1">
                      <label class="input-label form-label">{{
                        $t("feedbackFormFreeCasesOnly")
                      }}</label>
                      <input
                        class="form-check-input-custom ml-2"
                        v-model="form[`${product.key}FeedbackFormFreeCasesOnly`]"
                        type="checkbox"
                      />
                    </div>
                  </b-col>
                </b-row>
              </b-col>
            </template>
          </b-row>
        </div>
      </div>
      <div class="d-flex align-items-center justify-content-end">
        <b-button
          variant="primary"
          @click="save"
          class="d-flex align-items-center gap-1"
          :disabled="isFormInvalid"
          v-if="$can(`${$route.meta.permission}.save`)"
        >
          <feather-icon icon="PlusIcon" size="12" />
          <span>{{ $t("saveConfiguration") }}</span>
        </b-button>
      </div>
    </validation-observer>
    <div class="c-modal" v-show="showPreviewModal">
      <div class="c-modal-content">
        <div class="c-modal-header">
          <h3>
            {{
              previewJawType === "upper"
                ? $t("previewUpperJaw")
                : $t("previewLowerJaw")
            }}
          </h3>
          <div class="x-icon" @click="showPreviewModal = false">
            <feather-icon size="16" icon="XIcon" />
          </div>
        </div>
        <div class="c-modal-body">
          <PreviewModel v-if="showPreviewModal" :jaw="showJaw" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from "@/components/PageHeader.vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import TextInput from "@/components/TextInput.vue";
import { mapGetters } from "vuex";
import countries from "@/assets/data/countries.json";
import MultiSelect from "vue-multiselect";
import { required } from "@validations";
import FileService from "@/services/file.service";
import PreviewModel from "./components/PreviewModel.vue";
// import MillingHeadSizeTable from "./components/MillingHeadSizeTable.vue";
import { debounce } from "@/utils/debounce";
import fileHandlerMixin from "@/mixins/fileHandlerMixin";
import formDirtyMixin from "@/mixins/formDirtyMixin";

export default {
  components: {
    PageHeader,
    ValidationProvider,
    ValidationObserver,
    TextInput,
    PreviewModel,
    // MillingHeadSizeTable,
    MultiSelect,
  },
  mixins: [fileHandlerMixin, formDirtyMixin],
  data() {
    return {
      countries,
      products: [
        { key: "AIGeneration", label: "shellTempDesign", validationName: "DentaTEMP" },
        { key: "teethEggshell", label: "setupGuideForTeeth", validationName: "DentaCAD" },
        { key: "bridgesCrowns", label: "setupGuideForImplants", validationName: "DentaWAX" },
        { key: "dentaBridge", label: "dentaBridge", validationName: "DentaBridge" }
      ],
      form: {
        upperJawTemplate: {},
        lowerJawTemplate: {},
        toothCreditsCost: "",
        vhfKey: "",
        upperJawTemplateExtension: "",
        lowerJawTemplateExtension: "",
        technology: "",
        AIGenerationFeedbackFormUrl: "",
        AIGenerationFeedbackFormActive: false,
        AIGenerationFeedbackFormFreeCasesOnly: false,
        teethEggshellFeedbackFormUrl: "",
        teethEggshellFeedbackFormActive: false,
        teethEggshellFeedbackFormFreeCasesOnly: false,
        bridgesCrownsFeedbackFormUrl: "",
        bridgesCrownsFeedbackFormActive: false,
        bridgesCrownsFeedbackFormFreeCasesOnly: false,
        dentaBridgeFeedbackFormUrl: "",
        dentaBridgeFeedbackFormActive: false,
        dentaBridgeFeedbackFormFreeCasesOnly: false
      },
      originalForm: null,
      upperJawTemplate: "",
      lowerJawTemplate: "",
      upperJawTemplateExtension: "",
      lowerJawTemplateExtension: "",
      defaultTechnology: "",
      showPreviewModal: false,
      showJaw: null,
      previewJawType: null,
      tableRows: [],
    };
  },
  computed: {
    ...mapGetters(["showLoader"]),
    ...mapGetters("globalConfiguration", ["configuration"]),
    items() {
      return [
        {
          text: "Dental Twin",
          to: "/home",
        },
        {
          text: this.$t("globalConfiguration"),
          active: true,
        },
      ];
    },
    isFormInvalid() {
      // return this.products.some(
      //   (p) =>
      //     !this.form[`${p.key}Price`] ||
      //     !this.form[`${p.key}RecalculationFactor`]
      // );
      return false;
    },
    tableColumns() {
      return [
        {
          label: this.$t("value") || "Value",
          field: "value",
          sortable: false,
        },
        {
          label: this.$t("action") || "Action",
          field: "action",
          sortable: false,
        },
      ];
    },
  },
  watch: {
    search(...val) {
      this.debouncedFetch();
    },
    form: {
      handler(newVal) {
        this.isFormDirty = JSON.stringify(newVal) !== this.originalForm;
      },
      deep: true,
    },
  },
  async mounted() {
    await this.refresh();
  },
  methods: {
    handlePreviewClick(jawType) {
      if (jawType === "upper") {
        this.showJaw = this.upperJawTemplate;
        this.previewJawType = jawType;
      } else {
        this.showJaw = this.lowerJawTemplate;
        this.previewJawType = "lower";
      }
      this.showPreviewModal = true;
    },
    async refresh() {
      try {
        this.$store.commit("showLoader", true);
        await this.$store.dispatch("globalConfiguration/show");
        this.form.toothCreditsCost =
          this.configuration.toothCreditsCost ?? "3";
        this.form.vhfKey = this.configuration.vhfKey ?? "";
        this.products.forEach((p) => {
          this.form[`${p.key}FeedbackFormUrl`] =
            this.configuration[`${p.key}FeedbackFormUrl`] ?? "";
          const activeVal = this.configuration[`${p.key}FeedbackFormActive`];
          this.form[`${p.key}FeedbackFormActive`] =
            activeVal === true || activeVal === "1" || activeVal === 1;
          const freeCasesVal = this.configuration[`${p.key}FeedbackFormFreeCasesOnly`];
          this.form[`${p.key}FeedbackFormFreeCasesOnly`] =
            freeCasesVal === true || freeCasesVal === "1" || freeCasesVal === 1;
        });

        this.form.technology =
          this.configuration.technology ?? "";
        this.form.commDistance1 = this.configuration?.commDistance1 ?? "";
        this.form.commDistance2 = this.configuration?.commDistance2 ?? "";
        this.form.commDistance3 = this.configuration?.commDistance3 ?? "";
        this.form.commDistanceN = this.configuration?.commDistanceN ?? "";
        this.form.maxCommDistance1 = this.configuration?.maxCommDistance1 ?? "";
        this.form.maxCommDistance2 = this.configuration?.maxCommDistance2 ?? "";
        this.form.maxCommDistance3 = this.configuration?.maxCommDistance3 ?? "";
        this.form.maxCommDistanceN = this.configuration?.maxCommDistanceN ?? "";

        this.upperJawTemplate = this.configuration?.upperJawTemplate ?? "";
        this.lowerJawTemplate = this.configuration?.lowerJawTemplate ?? "";
        this.upperJawTemplateExtension =
          this.configuration?.upperJawTemplateExtension ?? "";
        this.defaultTechnology =
          this.configuration?.defaultTechnology ?? "";
        this.lowerJawTemplateExtension =
          this.configuration?.lowerJawTemplateExtension ?? "";

        // this.tableRows = this.configuration?.millingHeadSize ?? [];

        this.originalForm = JSON.stringify(this.form);
      } catch (e) {
        console.error("api error ___", e);
      } finally {
        this.$store.commit("showLoader", false);
      }
    },

    deleteFile(type) {
      if (type === "upper") {
        this.form.upperJawTemplate = null;
        this.$refs.upperInput.value = null;
      } else if (type === "lower") {
        this.form.lowerJawTemplate = null;
        this.$refs.lowerInput.value = null;
      }
    },
    addFile(event, type) {
      const file = event.target.files[0];
      if (type === "upper") this.form.upperJawTemplate = file;
      else this.form.lowerJawTemplate = file;
    },
    async save() {
      this.$refs.simpleRules.validate().then(async (success) => {
        if (success) {
          this.$store.commit("showLoader", true);
          const filePayload = {};

          if (this.form.upperJawTemplate && this.form.upperJawTemplate.name) {
            const response = await this.handleFileUpload(
              this.form.upperJawTemplate,
              { visibility: 1 },
              0,
              0.33
            );

            if (!response?.data[0]?.id) {
              this.$store.commit("showLoader", false);
              return;
            } else {
              filePayload.upperJawTemplate = response.data[0].id;
              filePayload.upperExtension = response.data[0].type;
            }
          }

          if (this.form.lowerJawTemplate && this.form.lowerJawTemplate.name) {
            const response2 = await this.handleFileUpload(
              this.form.lowerJawTemplate,
              { visibility: 1 },
              0,
              0.33
            );

            if (!response2?.data[0]?.id) {
              this.$store.commit("showLoader", false);
              return;
            } else {
              filePayload.lowerJawTemplate = response2.data[0].id;
              filePayload.lowerExtension = response2.data[0].type;
            }
          }

          // Dispatch everything in one go
          await this.$store.dispatch("globalConfiguration/save", {
            ...this.form,
            ...filePayload,
          });

          this.$store.commit("showLoader", false);
          this.form.lowerJawTemplate = {};
          this.form.upperJawTemplate = {};
          this.$refs.upperInput.value = null;
          this.$refs.lowerInput.value = null;
          this.isFormDirty = false;
          this.originalForm = JSON.stringify(this.form);
          await this.refresh();
        }
      });
    },
  },
};
</script>
